// extracted by mini-css-extract-plugin
module.exports = {"delimiter":"Duration_delimiter__0aksY","title":"Duration_title__AjMkN"};